import React from 'react';
import TextTransformer from './components/TextTransformer';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-neo-green">
      <TextTransformer />
    </div>
  );
}

export default App;
